export default __webpack_public_path__ + "static/15-2629301440ca8a648f16f919951bc5a2.png";